import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { resource } from "@util/resource";
import {
  WineryIntegration,
  WineryShipmentSettings,
  WineryShipmentSettingsId,
} from "@interfaces/dws/integration";

@Injectable({
  providedIn: "root",
})
export class ShippingService {
  getWineryIntegrations(wineryId: string): Observable<WineryIntegration[]> {
    return resource("crm://integrations/winery/wineryId")
      .params({ wineryId })
      .get();
  }

  createShippingSettings(
    wineryId: string,
    wineryShipmentSettingsIdList: WineryShipmentSettingsId[]
  ): Observable<any> {
    return resource("crm://shipping/wineryId/shipping-settings")
      .params({ wineryId })
      .post(wineryShipmentSettingsIdList);
  }

  getShippingSettings(wineryId: string): Observable<WineryShipmentSettings[]> {
    return resource("crm://shipping/wineryId/shipping-settings").params({ wineryId }).get();
  }

  updateShippingOffers(wineryId: string, patches: any[]): Observable<any> {
    return resource("crm://shipping/wineryId/shipping-settings/offers")
      .params({ wineryId })
      .put(patches);
  }

  simulateQuote(wineryId: string, body: any): Observable<any> {
    return resource("crm://shipping/wineryId/simulate").params({ wineryId }).post(body);
  }

  listAreas(wineryId: string): Observable<any[]> {
    return resource("crm://shipping/wineryId/areas").params({ wineryId }).get();
  }

  listZones(wineryId: string): Observable<any[]> {
    return resource("crm://shipping/wineryId/zones").params({ wineryId }).get();
  }

  saveZone(wineryId: string, zone: any): Observable<any> {
    return resource("crm://shipping/wineryId/zones").params({ wineryId }).post(zone);
  }

  previewZone(wineryId: string, body: any): Observable<any[]> {
    return resource("crm://shipping/wineryId/zones/preview").params({ wineryId }).post(body);
  }

  deleteZone(wineryId: string, zoneId: string): Observable<any> {
    return resource("crm://shipping/wineryId/zones/zoneId").params({ wineryId, zoneId }).delete();
  }

  archiveBlockers(wineryId: string, channelId: string): Observable<{ pendingPayments: number; prepShipments: number }> {
    return resource("crm://shipping/wineryId/archive-blockers").params({ wineryId, channelId }).get();
  }

  listFollowUps(wineryId: string, query: { [param: string]: string }): Observable<any> {
    return resource("crm://shipping/wineryId/follow-ups").params(Object.assign({ wineryId }, query)).get();
  }

  patchTracking(
    wineryId: string,
    shippingDataId: number,
    body: {
      carrier?: string;
      trackingId?: string;
      shipmentStatus?: string;
      parcels?: number;
      shippedAt?: string;
      deliveredAt?: string;
      trackingOnly?: boolean;
    }
  ): Observable<any> {
    return resource("crm://shipping/wineryId/follow-ups/shippingDataId/track")
      .params({ wineryId, shippingDataId: String(shippingDataId) })
      .put(body);
  }

  markPaid(wineryId: string, shippingDataId: number, body?: { collectedAt?: string }): Observable<any> {
    return resource("crm://shipping/wineryId/follow-ups/shippingDataId/mark-paid")
      .params({ wineryId, shippingDataId: String(shippingDataId) })
      .post(body || {});
  }

  cancelFollowUp(wineryId: string, shippingDataId: number): Observable<any> {
    return resource("crm://shipping/wineryId/follow-ups/shippingDataId/cancel")
      .params({ wineryId, shippingDataId: String(shippingDataId) })
      .post({});
  }

  suggestParcels(wineryId: string, shippingDataId: number): Observable<{ parcels: number }> {
    return resource("crm://shipping/wineryId/follow-ups/shippingDataId/suggest-parcels")
      .params({ wineryId, shippingDataId: String(shippingDataId) })
      .get();
  }

}
